import { matchupResults, calculatePickemWinner } from './rules/winnerRules';

// Calculation is independent of persistence so previews can recover results safely.
// Dependencies also let tests exercise the actual missing-document/write path offline.
export async function recoverWinners({ year, currentWeek, cards, read, loadLeague, loadRosters, loadMatchups, save, writable }) {
  const stored = await read();
  const winners = Array.from({ length: Math.max(19, stored.winners?.length || 0) }, (_, i) => stored.winners?.[i] ? JSON.parse(JSON.stringify(stored.winners[i])) : null);
  const recoveredWeeks = [];
  const pendingTiebreakers = [];
  let league, rosters, changed = false;
  for (let week = 1; week < Math.min(currentWeek, 19); week++) {
    const old = winners[week]?.data || {};
    let ids = old.picks || [];
    let matchupCount = ids.length;
    if (!ids.length) {
      league ||= await loadLeague();
      // Sleeper's leg is the current week, so it stays equal to a finished week until it rolls.
      // Allow leg >= week and require every matchup to have a real winner before settling.
      if (String(league.season) !== String(year) || !(Number(league.settings?.leg) >= week || league.status === 'complete')) continue;
      rosters ||= await loadRosters();
      const pairs = matchupResults(await loadMatchups(week), rosters, true);
      const expectedTeams = Number(league.total_rosters) || rosters.length;
      if (!pairs.length || pairs.length * 2 !== expectedTeams || pairs.some(p => !p.winnerId)) continue;
      ids = pairs.map(p => p.winnerId);
      matchupCount = pairs.length;
      recoveredWeeks.push(week);
    }
    const data = { ...old, picks: ids, tiebreaker: old.tiebreaker ?? '', winner_info: old.winner_info || ['', 0] };
    if (!data.winner_info[0]) {
      const weekCards = cards.filter(c => Number(c.Week) === week && c.Year === year);
      const settled = calculatePickemWinner(weekCards, ids, matchupCount, data.tiebreaker);
      if (settled) data.winner_info = settled;
      if (weekCards.length && data.tiebreaker === '') pendingTiebreakers.push(week);
    }
    const next = { ...(winners[week] || {}), data };
    if (JSON.stringify(next) !== JSON.stringify(winners[week])) changed = true;
    winners[week] = next;
  }
  let saveError = '';
  if (changed && writable) {
    try { await save(stored.id, winners); }
    catch { saveError = 'Results were calculated, but could not be saved. Refresh to retry.'; }
  }
  return { winners, recoveredWeeks, pendingTiebreakers, saveError };
}
